import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Layout from "../components/Layout";
import images from "../common/images";
import { useQuery } from "@tanstack/react-query";
import ApiCall from "../services/apiCall";
import Hero from "../components/Hero";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [email, setEmail] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const onSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    let data = JSON.stringify({
      email: email,
    });

    setLoading(true);
    try {
      const res = await ApiCall("api/forgot-password", "POST", data);
      if (res.ok) {
        // Navigate to dashboard or home page after login
        toast.success(
          typeof res?.message == "string"
            ? res?.message
            : "Something went wrong"
        );

        navigate("/otp", {
          state: {
            value: email,
            isPhoneNumber: false,
            isForget: true,
          },
        });
      } else {
        toast.error(
          res.errors?.length
            ? res.errors[0].msg
            : res.message || "Something went wrong"
        );
      }
    } catch (error) {
      toast.error(error.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Hero title="Forgot Password" />
      {/* Login Section */}
      <section
        className="login-section section-gap wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="midd-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-sec">
                <h2 className="title-30 wow fadeInUp" data-wow-delay="0.2s">
                  Forgot Password
                </h2>
              </div>
              <div className="form-sec">
                <form
                  className="wow fadeInUp"
                  data-wow-delay="0.2s"
                  onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit();
                  }}
                >
                  <div className="input-sec">
                    <input
                      type={"email"}
                      name={"email"}
                      placeholder={"Enter Your Email"}
                      className="form-control"
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setEmail(inputValue);
                      }}
                    />
                  </div>
                  <div className="btn-sec">
                    <button type="button" className="btn" onClick={onSubmit}>
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Login Section End */}
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
      <ToastContainer />
    </Layout>
  );
};

export default ForgotPassword;
